import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './PageTransition.module.css';

/**
 * 页面切换过渡动效
 */
export default function PageTransition({ children }) {
  const location = useLocation();

  return (
    <div key={location.pathname} className={styles.page}>
      {children}
    </div>
  );
}
